import { BorderedInput, Button } from '@navi/web-ui/lib/primitives';
import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import { useDispatch } from 'react-redux';
import { createProduct, getProductsByTenant } from '../../paramountActions';
import React, { useState } from 'react';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { Controller, useForm } from 'react-hook-form';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
import { GenericObject } from '@cp/src/types/CommonConstans';

const CreateProductDrawer = (props: {
  showCreateProduct: boolean;
  setShowCreateProduct: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { showCreateProduct, setShowCreateProduct } = props;
  const dispatch = useDispatch();

  const successCb = () => {
    setShowCreateProduct(false);
    dispatch(getProductsByTenant(tenant));
    reset();
    return;
  };

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors }
  } = useForm();
  const tenant = useGetTenant();
  const handleCreateProduct = (data: GenericObject) => {
    const { productName, productType, productCode } = data;
    dispatch(
      createProduct({ name: productName, type: productType, code: productCode }, tenant, successCb)
    );
  };
  return (
    <Drawer
      headerText="Add Product"
      open={showCreateProduct}
      showHeaderDivider={true}
      footer={
        <div className="flex justify-center">
          <Button
            variant="primary"
            size="medium"
            onClick={handleSubmit(handleCreateProduct)}
            className="w-[50%]"
          >
            Create Product
          </Button>
        </div>
      }
      onClose={() => {
        setShowCreateProduct(false);
      }}
      disableOutsideClick={false}
    >
      <div className="flex flex-col justify-between items-center gap-[20px] w-full">
        <form onSubmit={handleSubmit(handleCreateProduct)}>
          <Controller
            control={control}
            name={'productName'}
            rules={{ required: true }}
            render={({ field: { onChange, value, ref } }) => (
              <BorderedInput
                id="product-name"
                containerClassName={'w-[300px] mb-6'}
                placeholder="product Name"
                inputSize="full-width"
                type="text"
                inputLabel={'Product Name'}
                required={true}
                value={value}
                onChange={e => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
          <Controller
            control={control}
            name={'productCode'}
            rules={{ required: true }}
            render={({ field: { onChange, value, ref } }) => (
              <BorderedInput
                id="product-name"
                containerClassName={'w-[300px] mb-6'}
                placeholder="product Code"
                inputSize="full-width"
                type="text"
                inputLabel={'Product Code'}
                required={true}
                value={value}
                onChange={e => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
          <Controller
            control={control}
            name={'productType'}
            rules={{ required: true }}
            render={({ field: { onChange, value, ref } }) => (
              <BorderedInput
                id="product-name"
                containerClassName={'w-[300px]'}
                placeholder="product Type"
                inputSize="full-width"
                type="text"
                inputLabel={'Product Type'}
                required={true}
                value={value}
                onChange={e => {
                  onChange(e.target.value);
                }}
              />
            )}
          />
        </form>
      </div>
    </Drawer>
  );
};

export default CreateProductDrawer;
